import * as utility from "./services.js"
import { MetadataIndex } from "./metadata_indexer.js"
import { Tree, NodeChangeMode, SortableTreeNode } from "../core/components/sortableTree.js";
import { FullHeightContainer } from "../core/components/FullHeighContainer.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import React from "react";
export class WebSmsUiEditor extends React.Component<any, any> {
    private broadcastChannel: BroadcastChannel;

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (typeof BroadcastChannel !== 'undefined') {
            this.broadcastChannel = new BroadcastChannel(this.props.channel);
            this.broadcastChannel.onmessage = (ev) => {
                if (ev.data.message == "SENDMETA") {
                    this.setState({ metadata: ev.data.metadata, entity: ev.data.entity });
                }
            };
            this.broadcastChannel.postMessage({ message: "GETMETA" });
        }
    }

    handleMetaDataChanged = (translatedMetadata) => {
        this.broadcastChannel.postMessage({ message: "METACHANGED", metadata: translatedMetadata });
    }

    render() {
        const ui = <MetadataEditor metadataType={this.props.metadataType} entity={this.state.entity} onSettingsChanged={this.handleMetaDataChanged} settings={this.props.settings} />;

        return ui;
    }
};

interface WebsMSMetadataEditorState {
    rawMetadata?,
    newMetadata?,
    patchedMetadata?,
    metadataFiles?,
    selectedRawMetadata?,
    selectedNodeType?: "field" | "region" | "tab" | "app",
    selectedNode?,
    array?,
    index?,
    uiRoot?,
    addFieldDialog?
    isExternalUser?
}

class MetadataEditor extends React.Component<any, WebsMSMetadataEditorState> {
    private metadataIndex: MetadataIndex = new MetadataIndex();
    private treeRef: Tree;

    renderEntityFields(): any {
        return Object.keys(this.props.entity).map((s) => {
            return <div>{s}</div>
        });
    }

    constructor(props) {
        super(props);
        this.state = { selectedRawMetadata: null };
    }

    componentDidMount() {
        this.fetchData(false);
    }

    handleSave = () => {
        const metadataType = this.state.isExternalUser ? this.props.metadataType + "_external" : this.props.metadataType;
        utility.httpService.postJson(this.props.settings.INNO_BASE_PATH + 'Metadata/SaveNewMetadata', { metadataType: metadataType, metadata: JSON.stringify(this.state.rawMetadata, (key, value) => { return (key == "guid" || key == "_removed") ? undefined : value }, 2) },
            (result) => {
                NotificationHelper.showSuccessMessage("Saved successfully");
            }, null, null, true);
    }

    private fetchData = (isInternalUser: boolean) => {
        utility.httpService.get(this.props.settings.INNO_BASE_PATH + 'Metadata/GetMetadataForEditor', { metaDataType: this.props.metadataType, isExternalUser: isInternalUser },
            (result) => {

                try {
                    const newMetadata = JSON.parse(result.newMetadata);
                    const patchedMetadata = JSON.parse(result.patchedMetadata);
                    this.setState({ metadataFiles: result.jsonFiles, newMetadata: newMetadata, patchedMetadata: patchedMetadata, });
                } catch (e) {
                    alert(e);

                }


            }, null, true);
    }

    private changeExternal = (e) => {
        const isInternal = e.target.value;
        this.setState({ isExternalUser: isInternal });
    }

    renderProperties = (baseMetaData, patchedMetada) => {
        if (!baseMetaData) {
            return null;
        }
        const renderedPropertyLines = [];
        const allKeys = Object.keys(baseMetaData).filter(i => i != "additional" && i != "refs");
        const refs = baseMetaData["refs"];
        this.renderObj(baseMetaData, patchedMetada, renderedPropertyLines, allKeys, 0, refs, "");
        const allRefKeys = Object.keys(baseMetaData["refs"]);
        this.renderObj(refs, {}, renderedPropertyLines, allRefKeys, 0, refs, "refs")
        return renderedPropertyLines;
    }

    private renderObj = (obj: {}, patchObj: {}, resultArray: any[], keysToRender: string[], indentLevel: number, refObject, basePropertyPath: string) => {
        for (var key of keysToRender) {
            const value = obj[key];
            const patchedValue = patchObj ? patchObj[key] : undefined;
            if (this.state.isExternalUser === "true" && patchedValue === undefined) {
                continue;
            }
            if (value == null) {
                resultArray.push(<PropertyLine
                    key={basePropertyPath + key}
                    propertyPath={basePropertyPath + key}
                    leftPropertyName={key}
                    rightPropertyName={patchedValue === undefined ? "" : key}
                    leftValue={value}
                    rightValue={patchedValue}
                    indentLevel={indentLevel}
                    refObjects={refObject}
                    rowIndex={resultArray.length}></PropertyLine>)
            }
            else if (typeof value === "object") {
                resultArray.push(<PropertyLine
                    key={basePropertyPath + key}
                    propertyPath={basePropertyPath + key}
                    leftPropertyName={key} leftValue={""}
                    indentLevel={indentLevel}
                    rightPropertyName={patchedValue === undefined ? "" : key}
                    refObjects={refObject}
                    rightValue={""} rowIndex={resultArray.length}></PropertyLine >)
                const objectKeys = Object.keys(value);
                this.renderObj(value, patchedValue, resultArray, objectKeys, indentLevel + 1, refObject, basePropertyPath + key + ".");
            }
            else {
                resultArray.push(<PropertyLine
                    key={basePropertyPath + key}
                    propertyPath={basePropertyPath + key}
                    leftPropertyName={key}
                    rightPropertyName={patchedValue === undefined ? "" : key}
                    leftValue={value}
                    rightValue={patchedValue}
                    indentLevel={indentLevel}
                    refObjects={refObject}
                    rowIndex={resultArray.length}></PropertyLine>)
            }
        }
    }

    render() {
        return (
            <FullHeightContainer classes="flex-container--row">
                <div style={{ width: "50%", minWidth: 200, height: "100%", display: "flex", flexDirection: "column", overflowY: "auto" }}>
                    <div style={{ margin: "5px", backgroundColor: "lightgray" }}>
                        <Radiocomponent value={false} setExternal={this.changeExternal} />
                    </div>
                    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                        <div style={{ overflow: "auto" }}>
                            <PropertyEditorHeader />
                            {this.renderProperties(this.state.newMetadata, this.state.patchedMetadata)}
                        </div>
                    </div>
                </div>
            </FullHeightContainer >
        )
    }
}

const Radiocomponent = ({ value, setExternal }) => (
    <div style={{ display: "inline-flex", paddingLeft: "5px" }} onChange={setExternal}>
        <input type="radio" value="false" name="userType" defaultChecked={value === false} /> Show all
        <input type="radio" value="true" name="userType" defaultChecked={value === true} /> Show only changed
    </div>
);

function PropertyEditorHeader() {
    return (
        <div style={{ minHeight: "unset", display: "flex", flexDirection: "row", backgroundColor: "lightgray" }}>
            <div style={{ width: "250px" }}>
            </div>
            <div style={{ width: "50%", textAlign: "center" }}>
                Default
            </div>
            <div style={{ flex: 1, textAlign: "center" }}>
                Override
            </div>
        </div>
    );
}

function PropertyLine(props: { leftPropertyName: string, leftValue: string, rightPropertyName: string, rightValue: string, indentLevel: number, rowIndex: number, propertyPath: string, refObjects }) {
    const scrollIntoView = (refValue: string): any => {
        var element = document.getElementById("refs" + refValue);

        element.scrollIntoView();
        element.scrollIntoView(true);
    }

    return (
        <div id={props.propertyPath} className={props.rowIndex % 2 == 0 ? "evenPropertyRow" : "oddPropertyRow"} style={{ minHeight: "unset", display: "flex", flexDirection: "row" }}>
            <div style={{ width: "250px", borderRightColor: "lightgray", borderRightWidth: "1px", borderRightStyle: "solid", overflow: "clip", fontWeight: props.indentLevel <= 0 ? "bold" : null }}>
                <div style={{ color: props.rightPropertyName ? "orange" : "black", display: "inline", marginLeft: props.indentLevel * 20 + "px" }} title={props.propertyPath}>{props.leftPropertyName}</div>
            </div>
            <div style={{ width: "50%", borderRightColor: "lightgray", borderRightWidth: "1px", borderRightStyle: "solid" }}>
                {props.refObjects[props.leftValue] ? <a onClick={() => scrollIntoView(props.leftValue)}>{props.leftValue + ""}</a> : <pre style={{ overflow: "auto" }}>{props.leftValue + ""}</pre>}
            </div>
            <div style={{ flex: 1, display: "flex" }} >
                {props.rightPropertyName ? <pre style={{ overflow: "auto" }}>{props.rightValue + ""}</pre> : null}
                <div className="propertyRowOptions"><button>+</button><button>-</button></div>
            </div>
        </div>
    )
}

class MetadataFilesList extends React.Component<any, any> {

    render() {
        return (
            <div> Available metadata files
                {this.props.files.map(x => {
                    return <div>{x}</div>
                })}
            </div>)
    }
}


interface AddFieldDialogProps {
    onClose,
    onAddFieldClicked;
};

class AddFieldDialog extends React.Component<AddFieldDialogProps, any>{

    private dialogProps: DialogProps = {
        title: "Add field",
        actions: [
            {
                label: "Cancel",
                action: () => {
                    return true;
                }
            },
            {
                label: "Save",
                action: () => {
                    return false;
                },
                primary: true
            }],
        afterClose: () => {
            this.props.onClose && this.props.onClose();
        },
        width: 500,
        open: true
    }

    handleFieldClicked = (fieldType: string) => {
        this.props.onAddFieldClicked && this.props.onAddFieldClicked(fieldType)
    }

    renderFields = () => {
        let fields = [];
        const keys = Object.keys(utility.InnoCmp);
        keys.sort();
        for (var i of keys) {
            if (utility.InnoCmp[i].isField) {
                fields.push(<li onClick={this.handleFieldClicked.bind(this, i)}>{i}</li>);
            }
        }

        return fields;
    }

    render() {
        return <Dialog {...this.dialogProps}>
            <ul>
                {this.renderFields()}
            </ul>
        </Dialog>
    }
}